export default __webpack_public_path__ + "static/media/marketContext_loading.e264b9ac.png";